<template>
	<div>
		<navbar :title="title" />
		<van-form @submit="onSubmitdata">
			<van-field v-model="form.survey_name" name="项目名称" label="项目名称" placeholder="请输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目名称' }]" />
			<van-field v-model="form.led_name" name="屏幕名称" label="屏幕名称" placeholder="请输入屏幕名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入屏幕名称' }]" />
			<van-field v-model="client_text" name="关联客户" label="关联客户" placeholder="选择关联客户" readonly
				@click="popup.client = true" :rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]" />
			<!-- 添加地址输入框 -->
			<van-field v-model="mapdata.address" name="安装地址" label="安装地址" placeholder="点击选择安装地址" readonly @click="onloadMap"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择地址' }]" />
			<van-field v-if="file_list.length > 0" label="已上传附件">
				<template #input>
					<div v-for="(item, index) in file_list" :key="index" class="file-item">
						<van-image width="80" height="80" :src="fileUrl + item.file_id"
							@click="imgLook(fileUrl + item.file_id)" />
						<div class="del" @click="delImg(item, index)">
							<van-icon name="cross" color="#fff" size="12" />
						</div>
					</div>
				</template>
			</van-field>
			<van-field name="uploader">
				<template #label>
					<div>
						<span>安装现场</span>
						<div>图片上传</div>
					</div>
				</template>
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="6" accept="all" icon="upgrade"
						:after-read="onAfterRead" />
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="sign" icon="location-o" to="/sign">签到</van-tabbar-item>
			<van-tabbar-item name="list" icon="label-o" to="/sign/list">签到记录</van-tabbar-item>
			<van-tabbar-item name="survey" icon="browsing-history-o" to="/survey">勘察</van-tabbar-item>
			<van-tabbar-item name="surveyList" icon="certificate" to="/survey/list">勘察记录</van-tabbar-item>
		</van-tabbar>
		<van-popup v-model="popup.client" position="right" :style="{ width: '60%', height: '100%' }">
			<popup-select v-model="clientList.list" @onload="onloadClient" @check="checkClient"
				:loading="clientList.loading" :finished="clientList.finished" value-key="client_name"></popup-select>
		</van-popup>
		<van-popup v-model="popup.survey" position="right" :style="{ width: '100%', height: '90%' }">
			<iframe v-if="popup.survey" ref="myIframe" :src="iframeUrl" id="myIframe" frameborder="0" :key="iframeUrl"
				style="flex: 1; width: 100%; height: 100%; border: none;"></iframe>
		</van-popup>
		<!-- 地图弹出层 -->
			<AmapPicker 
			v-model="showMapPopup" 
			@address-selected="onAddressSelected" 
			:draggable="true" 
			:isSearch="true"
			:isbutton="true"
			:isNavigation="false"
			:columns="mapdata"/>
	</div>
</template>
<script>
import popupselect from "@/components/select/index";
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { post } from "@/api/dispatch";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils";
import { Dialog } from 'vant';
import global_url from "@/utils/global";
import IframeMessage from '@/utils/IframeMessage';
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import AmapPicker from "@/components/maps/AmapPicker.vue"; // 引入 AddressPicker 组件

let iframeMessage = null;
export default {
	name: "survey",
	components: {
		navbar,
		"popup-select": popupselect,
		AmapPicker // 注册 AddressPicker 组件

	},
	data() {
		return {
			title: "新增勘察",
			activeName: "survey",
			form: {
				client_id: "",
				uploader: [],
				},
			mapdata: {
				address: "", // 地址输入框
				latitude: 0, // 纬度
				longitude: 0, // 经度
				},
			client_text: "",
			popup: {
				client: false,
				calendar: false,
				survey: false
			},
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20
			},
			iframeUrl: "",
			design_data:"",
			survey_data: "",
			file_list: [],
			fileUrl: this.findUrl(),
            showMapPopup: false, // 地图弹出层显示状态
		};
	},
	mounted() {
		this.loadIframeUrl();
		this.fetchQuestionnaireData();
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			}
		},
		onSubmitdata() {
			if (this.form.uploader.length === 0 && this.file_list.length === 0) {
				return this.$toast.fail("请上传附件");
			}
			this.popup.survey = true
			this.init();
		},
		onSubmit(data) {
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("client_id", this.form.client_id);
			formData.append("survey_name", this.form.survey_name);
			formData.append("led_name", this.form.led_name);
			formData.append("surveyData", JSON.stringify(data.data));
			formData.append("design_id", this.design_id);
			formData.append("map_data", JSON.stringify(this.mapdata));
			formData.append("requestType", "survey_add");
			if (this.surveyId) {
				formData.append("survey_id", this.surveyId);
			}
			formData.append("token", getToken());
			const config = {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			};
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						Toast.success("提交成功!");
						this.$router.push({
							path: "/survey/list",
						});
					} else {
						Toast.fail("提交失败,请稍后重试!");
					}
				})
		},
		loadIframeUrl() {
			const fullUrl = this.GLOBAL.httpURL;
			const url = new URL(fullUrl);
			const protocol = url.protocol; // 获取协议部分 (http: 或 https:)
			const baseUrl = `${protocol}//${url.hostname}${url.port ? ':' + url.port : ''}`; // 包含协议和端口号的完整基础 URL
			this.iframeUrl = `${baseUrl}/survey/questionnaire/answer??isShowAnswerProgress=false&isShowCountdown=false&isShowAnswerSheet=false&isShowMarkQuestion=false&isShowClassifyAnswerSheet=false&isShowMarkers=false`; // 拼接成新的地址
			// this.iframeUrl = `/svey/questionnaire/answer??isShowAnswerProgress=false&isShowCountdown=false&isShowAnswerSheet=false&isShowMarkQuestion=false&isShowClassifyAnswerSheet=false&isShowMarkers=false`; // 拼接成新的地址
			
		},

		init() {
			if (this.popup.survey) { // 确保弹窗打开时才初始化
			if (iframeMessage) {
				iframeMessage.destroy();
			}
			iframeMessage = new IframeMessage('myIframe');
				if (this.design_data) {
					let data = { "": "" };
					let questionnaireData = JSON.parse(this.design_data);
					if (this.survey_data) {
						data = JSON.parse(this.survey_data);
					}
					iframeMessage.send({
						type: 'setQuestionnaireData',
						data: {
							questionnaireData, data
						}
					});
				} 
			// 监听消息
			iframeMessage.onMessage = (event) => {
				const { type, data } = event;
				// 提交问卷
				if (type === 'submitQuestionnaire') {
					// 关闭弹窗
					this.popup.survey = false;
					//携带数据发起提交请求
					this.onSubmit(data);
				}
			};
			}
		},
		closeSurveyPopup() {
			if (iframeMessage) {
				iframeMessage.destroy();
				iframeMessage = null;
			}
			this.popup.survey = false;
		},
		onloadClient(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			if (search != undefined) {
				this.clientList.page = 1;
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		checkClient(value) {
			this.popup.client = false;
			this.client_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		fetchQuestionnaireData() {
			const surveyId = this.$route.query.id;
			// if (search != undefined) {
			// 	this.clientList.page = 1;
			// }
			post({
				requestType: "design_data",
				survey_id: surveyId,
			})
				.then(res => {
					const data = res.obj;
					if(surveyId){
					this.title = "修改勘察单";
					this.form.survey_name = data.survey_name;
					this.client_text = data.client_name;
					this.form.led_name = data.led_name;
					this.form.client_id = data.client_id;
					this.survey_data = data.survey_data;
					this.surveyId = surveyId;
					}
					if (data.file_list) {
						this.file_list = JSON.parse(data.file_list);
					}
					if (data.map_data) {
						const map = JSON.parse(data.map_data);
						this.mapdata.latitude = map.latitude;
						this.mapdata.longitude = map.longitude;
						this.mapdata.address = map.address;
					}
					this.design_id = data.design_id;
					this.design_data = data.design_data;
				})
		},
		isTypeMp4(name) {
			return isMp4(name);
		},
		isTypeImage(name) {
			return isImage(name);
		},
		isType(name) {
			return istype(name);
		},
		findUrl() {
			return global_url.fileUrl;
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			// console.log(row);
			return Toast.fail("暂不支持该文件查看");
		},
		delImg(data) {
			// console.log(this.file_list.length);
			if (this.file_list.length > 1) {
				Dialog.confirm({
					title: '提示',
					message: '确定要删除该文件吗？',
				})
					.then(() => {
						let formData = new FormData();
						formData.append("file_id", data.file_id);
						formData.append("requestType", "survey_file_del");
						formData.append("survey_id", this.surveyId);
						formData.append("token", getToken());
						const config = {
							headers: {
								"Content-Type": "multipart/form-data"
							}
						};
						axios
							.post(this.GLOBAL.httpURL, formData, config)
							.then((res) => {
								if (res.data.code === 200) {
									Toast.success("删除成功!");
									this.fetchQuestionnaireData();
								} else {
									Toast.fail("删除失败,请稍后重试!");
								}
							})
							.catch(() => {
								Toast.fail("删除失败,请稍后重试!");
							});
					})
					.catch(() => {
						// 用户取消删除
					});
			} else {
				Toast.fail("至少保留一张附件!");
			}
		},
		onAddressSelected(value) {
			console.log(value);
			this.mapdata.address = value.address;
			this.mapdata.latitude = value.latitude;
			this.mapdata.longitude = value.longitude;
		},
		onloadMap() {
			this.showMapPopup = true;
		},
	},
};
</script>

<style scoped>
.van-icon-photograph:before {
	content: "\F0D2";
}
.file-item {
  position: relative;
  display: inline-block;
  margin-right: 10px; /* 可选：设置图片之间的间距 */
  width: 80px; /* 确保图片宽度 */
  height: 80px; /* 确保图片高度 */
  overflow: hidden; /* 确保内容不会溢出 */
}
.del {
  position: absolute;
  top: 1px; /* 调整删除按钮的垂直位置 */
  right: 1px; /* 调整删除按钮的水平位置 */
  background-color: rgba(0, 0, 0, 0.5); /* 可选：设置背景颜色以提高可点击性 */
  border-radius: 50%;
  padding: 2px; /* 可选：设置内边距 */
  cursor: pointer; /* 设置鼠标悬停时的光标样式 */
  z-index: 1; /* 确保删除按钮在图片上方 */
}
/* 搜索结果样式 */
.search-results {
  position: absolute;
  /* top: 60px; 根据需要调整 */
  left: 0;
  right: 0;
  max-height: 200px; /* 设置最大高度 */
  overflow-y: auto; /* 添加滚动条 */
  background-color: white; /* 设置背景颜色 */
  z-index: 10; /* 确保在地图上方 */
  border-bottom: 1px solid #ebedf0; /* 可选：添加底部边框 */
}
</style>